import axios, { AxiosInstance } from 'axios';

const NOTIFICATION_API_URL = import.meta.env.VITE_NOTIFICATION_API_URL;
const API_USERNAME = import.meta.env.VITE_API_USERNAME;
const API_PASSWORD = import.meta.env.VITE_API_PASSWORD;

export const notificationInstance: AxiosInstance = axios.create({
  baseURL: NOTIFICATION_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

notificationInstance.interceptors.request.use((config) => {
  config.auth = {
    username: API_USERNAME,
    password: API_PASSWORD,
  };

  return config;
});
